module.exports = __webpack_public_path__ + "img/no_baby_data.a18acecd.png";